#@import BookingTemplates
#@import BookingV2.gliveDealBookerInit
#@export GliveBookingWrapper

window.GliveBookingWrapper ?= {}

GliveBookingWrapper.init = ({gliveBooker}, done) ->
  return done() unless gliveBooker.isGliveDeal
  $ ->
    BookingV2.gliveDealBookerInit(false, gliveBooker, done)
